// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uf05","type":"styles_type__1IWjh","choices":"styles_choices__3Odaz"};